import { defineComponent as _defineComponent } from 'vue'
import { Ref, computed, ref } from 'vue';
import { throttle as _throttle, clamp } from 'lodash';
import { FullColorObject, HsvColor } from '@/composables/color';


export default /*#__PURE__*/_defineComponent({
  __name: 'SaturationBoard',
  props: {
    value: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'change', value: Partial<FullColorObject>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    value: FullColorObject;
};





const containerRef: Ref<HTMLDivElement | null> = ref(null);

const bgColor = computed(() => `hsl(${props.value.hsv.h}, 100%, 50%)`);
const pointerTop = computed(() => -props.value.hsv.v + 1 + 100 + '%');
const pointerLeft = computed(() => props.value.hsv.s + '%');

const handleChange = (e: MouseEvent | TouchEvent) => {
    e.preventDefault();

    const container = containerRef.value;

    // for some edge cases, container may not exist
    if (!container) return;

    const containerWidth = container.clientWidth;
    const containerHeight = container.clientHeight;

    const xOffset = container.getBoundingClientRect().left + window.scrollX;
    const yOffset = container.getBoundingClientRect().top + window.scrollY;
    const pageX = (e as MouseEvent).pageX || ((e as TouchEvent).touches ? (e as TouchEvent).touches[0].pageX : 0);
    const pageY = (e as MouseEvent).pageY || ((e as TouchEvent).touches ? (e as TouchEvent).touches[0].pageY : 0);
    const left = clamp(pageX - xOffset, 0, containerWidth);
    const top = clamp(pageY - yOffset, 0, containerHeight);
    const saturation = left / containerWidth;
    const bright = clamp(-(top / containerHeight) + 1, 0, 1);

    throttle({
        h: props.value.hsv.h,
        s: saturation * 100,
        v: bright * 100
    });
};

const onChange = (hsv: HsvColor) => {
    emit('change', { hsv });
};

const throttle = _throttle(onChange, 20, {
    leading: true,
    trailing: false
});

const handleMouseDown = (event: PointerEvent) => {
    event.preventDefault();
    const element = containerRef.value;
    if (!element) return;
    element.setPointerCapture(event.pointerId);
    handleChange((event as unknown) as MouseEvent);
};

const handleMouseMove = (event: PointerEvent) => {
    const element = containerRef.value;
    if (!element?.hasPointerCapture?.(event.pointerId)) return;
    handleChange((event as unknown) as MouseEvent);
};

const handleMouseUp = (event: PointerEvent) => {
    const element = containerRef.value;
    if (!element?.hasPointerCapture?.(event.pointerId)) return;
    handleChange((event as unknown) as MouseEvent);
    element.releasePointerCapture(event.pointerId);
};

return { __sfc: true,props, emit, containerRef, bgColor, pointerTop, pointerLeft, handleChange, onChange, throttle, handleMouseDown, handleMouseMove, handleMouseUp }
}

})